import { render, staticRenderFns } from "./CreateSingle.vue?vue&type=template&id=2c7c976e&"
import script from "./CreateSingle.vue?vue&type=script&lang=js&"
export * from "./CreateSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports